/**
 * Personalised Cards (Shopify-native)
 *
 * Companion to snippets/personalised-cards-shopify.liquid, which is a clone of
 * the Nosto recommendation template (nosto/templates/recommendations/
 * personalised-cards.html). They are separate because the Nosto template runs
 * server-side in the Nosto dashboard in Velocity (not Liquid) and was migrated
 * from Magento, so it is out of scope to change during this theme migration.
 *
 * Two responsibilities:
 *  1. Click handling for Shopify-rendered greeting cards. Each card carries
 *     data-* attributes and opens the existing personalisation popup
 *     (window.openProductPopup from nosto-personalized-cards-popup.js), reusing
 *     the same personalisation + add-to-cart flow as the Nosto carousel.
 *  2. Automatic fallback: when the cart block is set to the Nosto source, the
 *     Shopify cards are server-rendered into an inert <template> (no live DOM,
 *     no image loads). If the Nosto placement fails to render within a timeout,
 *     the template is cloned into place so the "Personalised Cards" block is
 *     never empty — keeping only one component in the DOM at any time.
 */
(function () {
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has('personalised-cards-shopify.js')) return;
    window.Eurus.loadedScript.add('personalised-cards-shopify.js');
  }

  // 1. Delegated click -> open the personalisation popup.
  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-personalised-card]');
    if (!card) return;
    event.preventDefault();

    if (typeof window.openProductPopup === 'function') {
      window.openProductPopup({
        id: card.dataset.productId,
        variantId: card.dataset.variantId,
        name: card.dataset.productName,
        url: card.dataset.productUrl
      });
    } else if (card.dataset.productUrl) {
      // Graceful degradation: popup script unavailable -> go to product page.
      window.location.href = card.dataset.productUrl;
    }
  });

  // 2. Nosto -> Shopify auto-fallback.
  // Once Nosto has failed once this page view, every subsequent section swap
  // re-renders a fresh inert template; re-arming with the full timeout would make
  // the cards flicker out for the whole timeout on each cart change. So we record
  // the failure and reveal immediately on later re-arms.
  var nostoFailed = false;

  function nostoHasContent(nostoEl) {
    if (!nostoEl) return false;
    // Nosto injects its carousel template into the placement element.
    if (nostoEl.querySelector('.nosto-block, swiper-container, .product-card')) {
      return true;
    }
    return nostoEl.children.length > 0;
  }

  function initFallback(tpl) {
    if (tpl.dataset.fallbackInit === 'true') return;
    tpl.dataset.fallbackInit = 'true';

    var targetId = tpl.dataset.nostoTarget;
    var timeout = parseInt(tpl.dataset.fallbackTimeout, 10) || 4000;
    var nostoEl = targetId ? document.getElementById(targetId) : null;

    // The fallback markup lives in an inert <template> so the Shopify grid is
    // never in the live DOM (no nodes, no image loads) unless Nosto fails. On
    // failure we clone the template in place and hide the empty Nosto element.
    function reveal() {
      if (tpl.dataset.fallbackRevealed === 'true') return;
      tpl.dataset.fallbackRevealed = 'true';
      nostoFailed = true;
      if (tpl.content && tpl.parentNode) {
        tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
      }
      if (nostoEl) nostoEl.classList.add('hidden');
    }

    function check() {
      if (!nostoHasContent(nostoEl)) reveal();
    }

    // Nosto already failed earlier -> don't wait again, fill the gap now.
    if (nostoFailed) {
      check();
    } else {
      window.setTimeout(check, timeout);
    }
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-nosto-cards-fallback]');
    for (var i = 0; i < wrappers.length; i++) {
      initFallback(wrappers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart sections are swapped on add-to-cart / quantity changes, which replaces
  // the fallback template (and any already-revealed cards) with a fresh inert
  // one. Re-scan after every swap so the fallback re-arms. 'cart:sections:swapped'
  // is dispatched by xCartHelper.swapSections (fires for all swap callers, unlike
  // 'cart:refresh' which only some dispatch).
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:sections:swapped', init);
})();
